import { Component, OnInit, forwardRef, Input, SimpleChanges, ViewChild } from '@angular/core';
import { 
    IonIcon
} from '@ionic/angular/standalone';
import { TranslatePipe } from '@ngx-translate/core';

import { DemoozMessageComponent, DemoozModalComponent, DemoozButtonComponent } from '@demooz/components';
import { QuestionsItemComponent, QuestionsAnswerComponent } from '@app/components';
import { DataService } from '@app/services';
import { Question } from '@app/models';

@Component({
    selector: 'app-questions-list',
    templateUrl: './list.component.html',
    styleUrls: ['./list.component.scss'],
    imports: [
        IonIcon, TranslatePipe, 
        forwardRef(() => DemoozMessageComponent), forwardRef(() => DemoozModalComponent), forwardRef(() => DemoozButtonComponent),
        forwardRef(() => QuestionsItemComponent), forwardRef(() => QuestionsAnswerComponent)
    ]
})
export class QuestionsListComponent  implements OnInit {
       
    @ViewChild('modalAnswer') modalAnswer: DemoozModalComponent;
    @Input({alias : 'questionID', required : false}) questionID: string;
      
    questionsNotAnswered: Array<Question> = [];
    questionsAnswered: Array<Question> = [];
    showBtnShareQuestion: boolean = false;
    displayQuestionsAnswered: boolean = false;
    questionToAnswer: Question|null = null;
      
    constructor(             
        public dataService: DataService
    ) { }

    ngOnInit() {
        let isShareSupported = (typeof navigator.share === 'function');
        this.showBtnShareQuestion = isShareSupported 
            && this.dataService.widget.value
            && this.dataService.operation.questionsContent?.isShareButtonVisible;
        this.initQuestions();
    }
    
    async ngOnChanges(changes: SimpleChanges) {
        if(changes['questionID'] && changes['questionID'].currentValue){
            if(this.questionID && this.questionID != ''){
                let question = this.questionsNotAnswered.find(q => q.ID === this.questionID);
                if(question){
                    this.onAnswerQuestion(question);
                }
            }
        }
    }
    
    initQuestions(){            
        this.questionsNotAnswered = this.dataService.ambassador.questionsNotAnswered;
        this.questionsAnswered = this.dataService.ambassador.questionsAnswered;
    }
    
    toggleQuestionsAnswered(){
        this.displayQuestionsAnswered = !this.displayQuestionsAnswered;
    }
    
    onAnswerQuestion(question: any){
        this.questionToAnswer = question;
        this.modalAnswer.open();
    }
    
    onSendAnswerQuestion(status: boolean){
        if(status){
            this.initQuestions();
            this.modalAnswer.dismiss();
        }
    }
    
    onDidDismissModalAnswer($event: any){
        this.questionToAnswer = null;
    }
        
    async shareLinkQuestion(){
        let urlWidget = this.dataService.widget.value?.url;
        if(urlWidget){
            let shareData = {
                title: ' ',
                text: '',
                url:  urlWidget + (urlWidget.indexOf('?') !== -1 ? '&' : '?') + 'a=' + this.dataService.ambassador.value?.ID + '&q=1'
            };
            await navigator.share(shareData);
        }
    }
}
